<template>
    <div class="home flex flex-align">
        <div class="constrain ff flex flex-center flex-align">
            <div class="description">
                <div class="wordmark">Jai.</div>
                <h1>Alliance-certified online<br />training for yoga studios.</h1>
            </div>
            <div class="ff">
                <form class="signup card elevated" @submit.prevent="go" v-if="!success">
                    <h2>Be among the first to try our online yoga curriculum.</h2>
                    <input type="text" class="signup-input" v-model="details.name" placeholder="Your Name" />
                    <input type="text" class="signup-input" v-model="details.email" placeholder="Email Address" />
                    <input type="text" class="signup-input" v-model="details.studio" placeholder="Yoga Studio" />
                    <input type="text" class="signup-input" v-model="details.city" placeholder="City"/>
                    <div class="error" v-if="error">{{error}}</div>
                    <div class="signup-options flex flex-align">
                        <button type="submit" :class="{disabled: attempting}">Join The List</button>
                        <loading size="small" v-if="attempting" />
                    </div>
                </form>
                <div class="signup-done card elevated" v-if="success">
                    <h2>All done.</h2>
                    <p>Thanks for your interest. We'll reach out soon to continue the conversation.</p>
                    <button @click="back">Back to Form</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'home',
        data(){
            return {
                url: 'https://script.google.com/macros/s/AKfycbwG3eowH2KVF4xTOXZa0p4cDlyf29jjgN7N8C2xNcJAXxOHaMw/exec',
                details: {},
                error: '',
                attempting: false,
                success: false,
            };
        },
        methods: {
            go(){
                for(const key of ['name', 'email', 'studio', 'city']){
                    if(!this.details[key]){
                        this.error = 'All fields are required.';
                        return;
                    }
                }

                this.attempting = true;

                axios.get(this.url, {params: this.details})
                .then(response => {
                    this.attempting = false;

                    if(response.data.result === 'success'){
                        this.success = true;
                        this.details = {};
                        this.error = '';
                    }else{
                        this.error = 'There was an error submitting your contact details. Please try again later.';
                    }
                })
                .catch(error => {
                    this.attempting = false;
                    this.error = 'There was an error submitting your contact details. Please try again later.';
                });
            },
            back(){
                this.success = false;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";
    @import "~@/assets/less/mixins";

    .home
    {
        width: 100vw;
        height: 100vh;
        background: url('~@/assets/full-bloom.png');
    }

    .description
    {
        flex: 1.25;
        padding-bottom: 50px;
    }

    .wordmark
    {
        font-size: 80px;
        font-weight: 700;
        color: @black;
        letter-spacing: -0.03rem;
        margin-bottom: 20px;
    }

    .signup
    {
        padding: 30px;
        max-width: 400px;

        h2
        {
            margin-bottom: 20px;
        }

        .signup-input
        {
            margin-bottom: 20px;
        }

        .signup-options
        {
            // margin-top: 30px;

            button
            {
                margin-right: 20px;
            }
        }

        .error
        {
            font-size: 13px;
            color: @base;
            font-weight: 500;
            margin-bottom: 20px;
        }
    }

    .signup-done
    {
        padding: 30px;
        max-width: 400px;

        h2
        {
            margin-bottom: 15px;
        }

        p
        {
            margin-bottom: 20px;
            font-size: 18px;
            font-weight: 500;
            line-height: 24px;
            color: @grey;
        }
    }
</style>
